import { useQuery } from 'react-query';
import { getAddressLookup } from '../api';
import { toUnderScoreSlug } from '../helpers/helpers';
import { useMemo, useState, useEffect } from 'react';
// import {debounce} from "@mui/material";
import debounce from 'lodash/debounce';

const DEBOUNCE_DELAY = 300,
  MAX_INPUT_LENGTH = 100;
const useAddressLookup = (search_term, mode = 'usps') => {
  const [debouncedTerm, setDebouncedTerm] = useState('');

  const sanitizedTerm = useMemo(
    () =>
      typeof search_term === 'string'
        ? search_term
            .slice(0, MAX_INPUT_LENGTH)
            .replace(/[^\w\s-#,.']/gi, '')
            .trim()
        : '',
    [search_term],
  );
  useEffect(() => {
    const handler = debounce(() => setDebouncedTerm(sanitizedTerm), DEBOUNCE_DELAY);
    handler();
    return () => handler.cancel();
  }, [sanitizedTerm]);

  const result = useQuery(
    ['address_search', mode, toUnderScoreSlug(debouncedTerm)],
    () => {
      if (!['usps', 'other'].includes(mode)) throw new Error('Invalid mode specified');
      return getAddressLookup(debouncedTerm, mode);
    },
    {
      enabled: debouncedTerm.length > 2,
      refetchOnWindowFocus: false,
      staleTime: 5000,
      cacheTime: 600000,
      retry: (failureCount, error) => failureCount < 2 && error.status !== 404,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),
      onError: (error) =>
        console.error('Address lookup error:', {
          term: debouncedTerm,
          mode,
          error: error.message,
        }),
    },
  );

  return { ...result, isValidInput: sanitizedTerm === search_term, sanitizedTerm };
};

export default useAddressLookup;
